import { TargetApp } from './api/types.js';

/**
 * Friendly product name per app, shared by the launcher tiles and the logout checklist.
 * Proper nouns — intentionally not localized.
 */
export function appDisplayName(app: TargetApp): string {
  switch (app) {
    case TargetApp.Crm:
      return 'Pinakes CRM';
    case TargetApp.Export:
      return 'Pinakes Export';
    case TargetApp.Callimachus:
      return 'Callimachus';
    default:
      return '';
  }
}

/**
 * Same friendly name, keyed by the canonical app string ('crm' | 'export' | 'callimachus') used in
 * `/go/{app}` and the `?app=` query of the no-access page. Returns '' for an unknown key.
 */
export function appDisplayNameForKey(key: string): string {
  switch (key) {
    case 'crm':
      return appDisplayName(TargetApp.Crm);
    case 'export':
      return appDisplayName(TargetApp.Export);
    case 'callimachus':
      return appDisplayName(TargetApp.Callimachus);
    default:
      return '';
  }
}
